import type { ContentType, RangeProperties } from "@ca.vmedia.tv/domains";

export class WatchedRange {
    /**
     * WatchedRange constructor.
     *
     * @param {number | null} id
     * @param {ContentType | null} type
     * @param {RangeProperties[] | null | undefined} range
     */
    public constructor(
        /**
         * WatchedRange identifier.
         */
        public id: number | null,
        public type: ContentType | null,
        public range: RangeProperties[] | null | undefined,
    ) {}
};
